import { Link } from 'react-router'
import { formatNumber } from '@/lib/format'
import { useTranslation } from 'react-i18next'
import { useCurrentTeam } from '@/features/team/current-team'
import { useTeamStats } from '@/features/team/queries'
import { cn } from '@/lib/utils'

/** v1 MenuCard: usage against the plan's limits, admin only. */
export function PlanUsage() {
  const { t } = useTranslation()
  const { current } = useCurrentTeam()
  const { data: stats } = useTeamStats()
  const limits = current?.plan?.Limits
  if (!limits || !stats) return null

  const rows = [
    { label: t('common.companies'), used: stats.companies, max: limits.companies, skipped: stats.skipped },
    { label: t('common.users'), used: stats.users, max: limits.users },
    { label: t('common.integrations'), used: stats.integrations, max: limits.integrations },
  ].filter((r) => r.max !== undefined)

  return (
    <Link
      to="/settings/subscription"
      className="group-data-[collapsible=icon]:hidden mx-2 mb-1 block rounded-lg p-3 ring-1 ring-sidebar-border outline-none transition-colors hover:bg-sidebar-accent focus-visible:ring-2 focus-visible:ring-sidebar-ring"
    >
      <span className="flex items-baseline justify-between text-sm">
        <span className="font-semibold">{current?.plan.Name}</span>
        <span className="text-xs text-muted-foreground">{t('v2.plan.manage')}</span>
      </span>
      <span className="mt-3 flex flex-col gap-2.5">
        {rows.map((r) => {
          const pct = r.max > 0 ? Math.min(100, (r.used / r.max) * 100) : 0
          return (
            <span key={r.label} className="block">
              <span className="flex justify-between text-xs text-muted-foreground">
                <span>{r.label}</span>
                <span className="figures">
                  {formatNumber(r.used)} / {formatNumber(r.max)}
                </span>
              </span>
              <span className="mt-1 block h-1 overflow-hidden rounded-full bg-sidebar-border">
                <span
                  className={cn('block h-full rounded-full', pct >= 100 ? 'bg-destructive' : pct >= 80 ? 'bg-window' : 'bg-primary')}
                  style={{ width: `${pct}%` }}
                />
              </span>
              {!!r.skipped && <span className="mt-1 block text-xs text-destructive">{t('v2.limits.skipped', { count: r.skipped })}</span>}
            </span>
          )
        })}
      </span>
    </Link>
  )
}
